import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import { useOptionContract as r } from "../store/optionContract.mjs";
import "../store/subgraph.mjs";
function f(t, n) {
  return r(t, !0).enter(n);
}
function m(t) {
  return r(t, !0).exitAll();
}
function R(t, n) {
  return r(t, !0).withdrawTarget(n);
}
function d(t, n) {
  return r(t, !0).unwind(n);
}
function w(t, n) {
  return r(t, !0).exercise(n);
}
function h(t) {
  return r(t).sniper();
}
function l(t) {
  return r(t).optionEntryFeeRatio().then((o) => Number(o));
}
function F(t) {
  return r(t).optionExerciseFeeRatio().then((o) => Number(o));
}
function x(t) {
  return r(t).optionWithdrawFeeRatio().then((o) => Number(o));
}
function b(t) {
  return r(t).optionRedeemFeeRatio().then((o) => Number(o));
}
function N(t) {
  return r(t).optionBulletToRewardRatio().then((o) => Number(o));
}
async function E(t) {
  return await r(t).fund();
}
export {
  f as enter,
  w as exercise,
  m as exitAll,
  E as fund,
  N as optionBulletToRewardRatio,
  l as optionEntryFeeRatio,
  F as optionExerciseFeeRatio,
  b as optionRedeemFeeRatio,
  x as optionWithdrawFeeRatio,
  h as sniper,
  d as unwind,
  R as withdrawTarget
};
//# sourceMappingURL=option.mjs.map
